<script>
	import Filters from '$lib/components/Filters.svelte'

	export let data
</script>

<Filters {data} />

<slot />
